import React, { useMemo } from "react";
// icons
import PaperIcon from "@frameworks/pmsjourney/asstes/paper.svg";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/draft.scss";
import Upgrade from "@frameworks/shared-library/assets/images/features/Markets/NCD/upgrade.svg";
import RefundInitiated from "@frameworks/shared-library/assets/images/features/Markets/NCD/refund-initiated.svg";
import Failed from "@frameworks/shared-library/assets/images/features/Markets/NCD/failed.svg";
import DraftAlreadyExists from "@frameworks/shared-library/assets/images/features/Markets/Pms/product.svg";
import { useSelector } from "react-redux";
import { useMessage } from "@frameworks/NCD/Hook/TransactionJourney/useMessage";
import YelloInfoDocument from "@frameworks/shared-library/assets/images/features/Markets/Ncd/confirm-rm-selection.svg";
export var TransactionTypeStatusEnum;
(function (TransactionTypeStatusEnum) {
    TransactionTypeStatusEnum["Unverified"] = "Unverified";
    TransactionTypeStatusEnum["Unselected"] = "Unselected";
    TransactionTypeStatusEnum["Selected"] = "Selected";
    TransactionTypeStatusEnum["Failed"] = "Failed";
    TransactionTypeStatusEnum["DraftAlreadyExists"] = "DraftAlreadyExists";
    TransactionTypeStatusEnum["Initiated"] = "Initiated";
    TransactionTypeStatusEnum["AddDpDetails"] = "AddDpDetails";
    TransactionTypeStatusEnum["ConfirmRMSelection"] = "ConfirmRMSelection";
})(TransactionTypeStatusEnum || (TransactionTypeStatusEnum = {}));
var Status = function (_a) {
    var status = _a.status, width = _a.width, _b = _a.imageWidth, imageWidth = _b === void 0 ? 140.47 : _b, _c = _a.imageHeight, imageHeight = _c === void 0 ? 99.95 : _c, title = _a.title, subText = _a.subText;
    var subCategoryId = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).subCategoryId;
    var productName = useMessage(subCategoryId);
    var messages = useMemo(function () {
        var _a;
        return (_a = {},
            _a[TransactionTypeStatusEnum.Unverified] = {
                icon: Upgrade,
                title: title,
                subtitle: subText,
            },
            _a[TransactionTypeStatusEnum.AddDpDetails] = {
                icon: Upgrade,
                title: "Add DP Details",
                subtitle: "Please update your client’s DP details via BULLPEN to enable order placement.",
            },
            _a[TransactionTypeStatusEnum.Unselected] = {
                icon: PaperIcon,
                title: "Great! Your client\u2019s ".concat(productName, " order has been placed."),
                subtitle: "Payment should be completed in 2 days else the order will be rejected. Track your order status in the Orderbook for the latest updates.",
            },
            _a[TransactionTypeStatusEnum.Selected] = {
                icon: PaperIcon,
                title: "Great! Your client\u2019s ".concat(productName, " order has been placed."),
                subtitle: "The next step is QC, which you can track in the Orderbook, along with all other status updates.",
            },
            _a[TransactionTypeStatusEnum.Failed] = {
                icon: Failed,
                title: title ? title : "Order Submission Failed",
                subtitle: subText,
            },
            _a[TransactionTypeStatusEnum.DraftAlreadyExists] = {
                icon: DraftAlreadyExists,
                title: "Draft Already Exists!",
                subtitle: "A draft with the same name and value already exists. Would you like to continue editing the draft?",
            },
            _a[TransactionTypeStatusEnum.Initiated] = {
                icon: RefundInitiated,
                title: "Your refund request has been successfully initiated.",
                subtitle: "Your request will be reviewed by the Operations team, and you can track its status in the Order Book after 1-2 days.",
            },
            _a[TransactionTypeStatusEnum.ConfirmRMSelection] = {
                icon: YelloInfoDocument,
                title: title ? title : "Confirm RM Selection!",
                subtitle: subText
                    ? subText
                    : "The RM details selected does not belong to client owner, do you still want to proceed",
            },
            _a);
    }, [productName]);
    var message = messages[status];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "draft-already-container bg-transparent d-flex flex-column align-items-center h-100 gap-30 client-verfied-height" }, message && (React.createElement(React.Fragment, null,
            React.createElement("img", { src: message.icon, alt: "PaperIcon", style: { width: "".concat(imageWidth, "px"), height: "".concat(imageHeight, "px") } }),
            React.createElement("div", { className: "draft-already-inner gap-1", style: { width: "".concat(width, "px") } },
                React.createElement("h6", { className: "DMSansMedium_20_500 text-center mb-0" }, message.title),
                React.createElement("p", { className: "DMSans_13_400", style: { maxWidth: "".concat(width, "px") } }, message.subtitle)))))));
};
export default Status;
